import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { LocalToken, LocalTokenGroup, NewLocalTokenGroup, UpdateLocalTokenGroup } from './model';

const client = createClient('/rest/authorization/local/token-group');

// Note: the location (pool) side is managed via the location, not the local token group.
export const localTokenGroupPermissions = {
  SEARCH: 'cpms.search-local-token-groups',
  GET: 'cpms.get-local-token-group',
  CREATE: 'cpms.create-local-token-group',
  UPDATE: 'cpms.update-local-token-group',
  DELETE: 'cpms.delete-local-token-group',
  SEARCH_TOKENS: 'cpms.search-local-token-group-tokens',
  ADD_TOKENS: 'cpms.add-local-token-group-tokens',
  DISABLE: 'cpms.disable-local-token-group',
  ENABLE: 'cpms.enable-local-token-group',
  REMOVE_TOKENS: 'cpms.remove-local-token-group-tokens'
};

export const searchLocalTokenGroups: SearchOperation<LocalTokenGroup> = searchRequestFactory<LocalTokenGroup>(client, {
  pattern: '',
  permissionId: localTokenGroupPermissions.SEARCH
});

export const getLocalTokenGroup: FindOperation<LocalTokenGroup, string> = getRequestFactory<LocalTokenGroup, string>(
  client,
  {
    permissionId: localTokenGroupPermissions.GET
  }
);

export const createLocalTokenGroup: SaveOperation<NewLocalTokenGroup> = postRequestFactory<
  NewLocalTokenGroup,
  LocalTokenGroup
>(client, {
  pattern: '',
  permissionId: localTokenGroupPermissions.CREATE
});

export const updateLocalTokenGroup: SaveOperation<UpdateLocalTokenGroup> = putRequestFactory<
  UpdateLocalTokenGroup,
  LocalTokenGroup,
  string
>(client, { pattern: '/{localTokenGroupId}', permissionId: localTokenGroupPermissions.UPDATE });

export const deleteLocalTokenGroup: DeleteOperation<void> = deleteRequestFactory<void, string>(client, {
  permissionId: localTokenGroupPermissions.DELETE
});

export const searchLocalTokenGroupLocalTokens: SearchOperation<LocalToken, object> = searchRequestFactory<
  LocalToken,
  object
>(client, {
  pattern: '/{localTokenGroupId}/tokens',
  permissionId: localTokenGroupPermissions.SEARCH_TOKENS
});

// Commands
export interface AddTokensCommand {
  replace: boolean;
  hiddenIds: string[];
}

export const addTokensToLocalTokenGroup: SaveOperation<AddTokensCommand, void, string> = postRequestFactory<
  AddTokensCommand,
  void,
  string
>(client, { pattern: '/{localTokenGroupId}/add-tokens', permissionId: localTokenGroupPermissions.ADD_TOKENS });

export const disableLocalTokenGroup: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(
  client,
  {
    pattern: '/{localTokenGroupId}/disable',
    permissionId: localTokenGroupPermissions.DISABLE
  }
);

export const enableLocalTokenGroup: SaveOperation<void, void, string> = postRequestFactory<void, void, string>(client, {
  pattern: '/{localTokenGroupId}/enable',
  permissionId: localTokenGroupPermissions.ENABLE
});

export interface RemoveTokensCommand {
  hiddenIds: string[];
}

export const removeTokensFromLocalTokenGroup: SaveOperation<RemoveTokensCommand, void, string> = postRequestFactory<
  RemoveTokensCommand,
  void,
  string
>(client, {
  pattern: '/{localTokenGroupId}/remove-tokens',
  permissionId: localTokenGroupPermissions.REMOVE_TOKENS
});
